<template>
  <div class="registerCandidate" id="registerCandidate">
    <navbar/>
    <div class="modal">
      <div class="modal-content center-align text-center">
        <h4 v-html="errorMsg"></h4>
        <p><slot name="note"></slot></p>
      </div>
      <div class="modal-footer">
        <a class="modal-action blue modal-close waves-effect waves-ripple btn-flat center-align text-center" style="color: #fff !important;">close</a>
      </div>
    </div>
    <a class="btn blue right waves-effect" id="freBtn" @click="toRegFr">FRANÇAIS</a>
      <a class="btn blue right waves-effect" id="engBtn" @click="toRegEn">ENGLISH</a>
    <div class="registrationPanel">
      <div class="row">
        <h3 class="text-center center-align header application">APPLICATION FOR PLATINUM REASONING CONTEST 2018</h3>
        <div class="col s12 m3 white z-depth-1" id="regEn">
          <h4>Instructions</h4>
          <p class="instructionText">
            <ul>
              <li>&bull;&nbsp;&nbsp;All fields are required</li>
              <li>&bull;&nbsp;&nbsp;Ensure you enter correctly your first name followed by your last name.</li>
              <li>&bull;&nbsp;&nbsp;Ensure one attachment uploaded before uploading the other.</li>
              <li>&bull;&nbsp;&nbsp;A recent scanned copy of your passport photograph, not more than three months old is required.</li>
              <li>&bull;&nbsp;&nbsp;Ensure you include your country code along with your phone number.</li>
              <li>&bull;&nbsp;&nbsp;
Entrez correctement le nom de votre institution</li>
              <li>&bull;&nbsp;&nbsp;A scanned copy of your school identity card or admission letter, or any other means of identification as a student and must be a recent one.</li>
              <li>&bull;&nbsp;&nbsp;Ensure your attachments is successfully uploaded before you click on register. Failure to do so invalidates your application.</li>
            </ul>
          </p>
          <p class="note">NOTE: <br/>Passport attachment must not be greater than 130kb in size and 200kb for identification. Supported file types include:<br/>
            &bull;&nbsp;&nbsp;passport: <ul style="display: inline-flex;">
              <li>*jpg</li>,
              <li>*png</li>,
              <li>*bmp</li>
            </ul>,<br/>
            &bull;&nbsp;&nbsp;identification: <ul style="display: inline-flex;">
              <li>*pdf</li>,
              <li>*jpg</li>,
              <li>*png</li>
              </ul>
          </p>
        </div>
        <div class="col s12 m3 white z-depth-1" id="regFr">
          <h4>Instructions</h4>
          <p class="instructionText">
            <ul>
              <li>&bull;&nbsp;&nbsp;Tous les champs sont requis</li>
              <li>&bull;&nbsp;&nbsp; Assurez-vous d'entrer correctement votre prénom suivi de votre nom de famille.</li>
              <li>&bull;&nbsp;&nbsp;
              Une copie scannée récente de votre photo d'identité, datant de moins de trois mois, est requise.</li>
              <li>&bull;&nbsp;&nbsp;Assurez-vous qu'une pièce jointe a été téléchargée avant de télécharger l'autre.</li>
              <li>&bull;&nbsp;&nbsp;
Assurez-vous d'inclure votre code de pays avec votre numéro de téléphone.</li>
              <li>&bull;&nbsp;&nbsp;Enter correctly the name of your institution</li>
              <li>&bull;&nbsp;&nbsp;
Une copie scannée de votre carte d'identité scolaire ou de votre lettre d'admission, ou tout autre moyen d'identification en tant qu'étudiant et doit être récente.</li>
              <li>&bull;&nbsp;&nbsp;
Assurez-vous que vos pièces jointes ont bien été téléchargées avant de cliquer sur Enregistrer. Ne pas le faire invalide votre demande.</li>
            </ul>
          </p>
          <p class="note">NOTE: <br/>
La taille du passeport ne doit pas dépasser 130 Ko et 200 Ko pour l'identification. Les types de fichiers pris en charge incluent:<br/>
            &bull;&nbsp;&nbsp;passeport:<ul style="display: inline-flex;">
              <li>*jpg</li>,
              <li>*png</li>,
              <li>*bmp</li>
            </ul>,<br/>
            &bull;&nbsp;&nbsp;
identification:<ul style="display: inline-flex;">
              <li>*pdf</li>,
              <li>*jpg</li>,
              <li>*png</li>
              </ul>
          </p>
        </div>
        <div class="col s12 m8  white offset-m1 z-depth-3">
          <h4 class="center-align text-align">Registration</h4>
          <hr/>
          <div class="row">
            <form class="col s12" @submit.prevent="validateForm" @input="errorMsg">
             <p class="center-align text-center">
                <!-- <small class="errorText red-text x1 text-center center-align" style="font-size: 1rem;" v-html="errorMsg"></small> -->
             </p>
              <div class="row">
                <div class="input-field col m6 s12">
                  <input placeholder="Enter your first name followed by your last name" id="full_name" type="text" class="validate" required v-model="formData.fullName">
                  <!-- eslint disable-next-line -->
                  <label for="full_name" class="active">Full Name |
Nom complet</label>
                </div>
                <div class="input-field col m6 s12">
                  <select style="margin-top: 0.7rem;" v-model="formData.gender">
                    <option value="" disabled>Choose your gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  <!-- eslint disable-next-line -->
                   <label class="active">Gender | Le genre</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col m6 s12">
                  <input type="email" id="email" class="validate" required v-model="formData.email">
                  <!-- eslint disable-next-line -->
                  <label for="email">Email Address | Adresse e-mail</label>
                </div>
                <div class="input-field col m6 s12">
                  <input type="tel" id="phoneNo" class="validate" required v-model="formData.tel">
                  <!-- eslint disable-next-line -->
                  <label for="phoneNo">Telephone | Téléphone</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col m6 s12">
                  <input type="text" class="datepicker" id="dob"  @change="getDob">
                  <!-- eslint disable-next-line -->
                  <label for="dob" class="active">Date of birth | Date de naissance</label>
                  <small class="red-text">{{dobErr}}</small>
                </div>
                <div class="file-field input-field col m6 s12">
                  <div class="btn grey darken-3">
                    <!-- eslint disable-next-line -->
                    <span>Passport photograph |
Photographie de passeport</span>
                    <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
                  </div>
                  <div class="file-path-wrapper">
                    <input class="file-path validate" type="text">
                  </div>
                  <!-- eslint disable-next-line -->
                  <small class="note red-text">scanned copy of your recent passport |<br/> copie numérisée de votre passeport récent.</small><br/>
                  <small  class="center center-align text-center" v-if="isSaving">
                    <i class="fa fa-circle-o-notch fa-pulse x2 left white-text fa-2x" style="color: #fff !important; font-size: 2rem;"></i>
                    <i class="icon ion-loading-c"></i> Uploading...
                    </small>
                  <small v-if="isFailed" class="red-text">{{failText}}</small>
                  <small v-if="isSuccess">Image uploaded</small>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m6">
                  <input type="text" id="institution" class="validate" required v-model="formData.institution">
                  <label for="institution">Institution</label>
                </div>
                <div class="file-field input-field col m6 s12">
                  <div class="btn grey darken-3">
                    <span>Identification</span>
                    <input type="file" :name="uploadIdName" :disabled="isSavingId" @change="idChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
                  </div>
                  <div class="file-path-wrapper">
                    <input class="file-path validate" type="text">
                  </div>
                  <!-- eslint disable-next-line -->
                  <small class="note red-text">scanned copy of identification document |<br>
copie scannée du document d'identification.</small><br/>
                  <small  class="center center-align text-center" v-if="isSavingId">
                    <i class="fa fa-circle-o-notch fa-pulse x2 left white-text fa-2x" style="color: #fff !important; font-size: 2rem;"></i>
                    <i class="icon ion-loading-c"></i> Uploading...
                    </small>
                  <small v-if="isFailedId" class="red-text">{{failIdText}}</small>
                  <small v-if="isSuccessId">File uploaded</small>
                </div>
              </div>
              <br/>
              <div class="row">
                <div class="input-field col s12 m6">
                  <select id="country" required v-model="formData.country" @change="assignState" class="validate  ">
                    <option value="" disabled>Select Country --</option>
                    <option v-for="(allcountry, index) in allcountries" :key="index"  :value="allcountry.name">{{allcountry.name}}</option>
                  </select>
                  <!-- eslint disable-next-line -->
                  <label class="active" style="margin-top: -1rem;">Nationality | Nationalité</label>
                </div>
                <div class="input-field col s12 m6">
                  <select id="region" required v-model="formData.state" @change="assignRegion">
                    <option value="" disabled>Select State --</option>
                    <option v-for="(allState, index) in allStates" :key="index" :value="allState.name">{{allState.name}}</option>
                  </select>
                  <label class="active" style="margin-top: -1rem;">State/Province</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m6">
                  <select id="lg" v-model="formData.lga">
                    <option value="" disabled>Select Region --</option>
                    <option v-for="(allLg, index) in allLgs" :key="index" :value="allLg.name">{{allLg.name}}</option>
                  </select>
                  <label class="active" style="margin-top: -1rem;">Region/City</label>
                </div>
                <div class="input-field col s12 m6">
                  <textarea id="address" class="validate materialize-textarea" required v-model="formData.address"></textarea>
                  <label for="address">Residential Address |
Adresse résidentielle</label>
                </div>
              </div>
              <div class="row">
                 <div class="input-field col s12 m6">
                  <input type="text" id="bankName" class="validate" required v-model="formData.bankName">
                  <label for="bankName">Bank Name | Nom de banque</label>
                </div>
                <div class="input-field col s12 m6">
                  <input type="tel" id="acctNo" class="validate" required v-model="formData.bankAcctNo">
                  <label for="acctNo">Bank Account Number |
Numéro de compte bancaire</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12 m6 offset-m3">
                  <input type="text" id="referalCode" class="validate" required v-model="formData.rCode">
                  <label for="referalCode">Registration Code |
Code d'enregistrement</label>
                </div>
              </div>
              <p class="center-align text-center" id="p-text">
                <spinner id="spinner-load"/>
                <br/>
                <a class="btn grey darken-3 center-align waves-effect" @click="registerCandidate" id="registerCandidateBtn">Register</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
import M from 'materialize-css'
import countries from 'country-state-city'
import $ from 'jquery'
import AuthService from '@/services/authService'
import Spinner from 'vue-simple-spinner'
import * as axios from 'axios'
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
const STATUS_INITIAL_ID = 4
const STATUS_SAVING_ID = 5
const STATUS_SUCCESS_ID = 6
const STATUS_FAILED_ID = 7
export default {
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      formData: {
        country: '',
        state: '',
        lga: '',
        address: '',
        fullName: '',
        gender: '',
        email: '',
        tel: '',
        dob: '',
        photoUrl: '',
        institution: '',
        idUrl: '',
        bankName: '',
        bankAcctNo: '',
        rCode: ''
      },
      allcountries: [],
      allStates: [],
      allLgs: [],
      countryId: '',
      stateId: '',
      errorMsg: '',
      responseTrigger: '',
      responseNote: '',
      responseText: '',
      dobErr: '',
      uploadedFiles: [],
      uploadedIds: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos',
      uploadIdName: 'photos',
      imgUrl: '',
      idUrl: '',
      failText: '',
      failIdText: ''
    }
  },
  components: {Navbar, FooterPage, Spinner},
  mounted () {
    $('#engBtn').hide()
    $('#regFr').hide()
    document.getElementById('spinner-load').style.display = 'none'
    var elem = document.querySelector('.modal')
    // eslint-disable-next-line
    var instance = new M.Modal(elem, {})
    this.responseTrigger = instance
    this.reset()
    this.resetId()
    this.allcountries = countries.getAllCountries()
    var elemDob = document.querySelector('#dob')
    // eslint-disable-next-line
    var instance = new M.Datepicker(elemDob, {
      yearRange: 35
    })

    $('#address').val('')
    $('#address').trigger('autoresize')

    let newPath = this.$route.fullPath
    if (newPath.split('-')[6]) {
      $('#registerCandidate > div.registrationPanel > div > div.col.s12.m8.white.offset-m1.z-depth-3 > div > form > div:nth-child(10) > div > label').addClass('active')
      this.formData.rCode = newPath.split('-')[6]
    }
  },
  methods: {
    toRegFr () {
      $('#freBtn').hide()
      $('#engBtn').show()
      $('#regFr').show()
      $('#regEn').hide()
    },
    toRegEn () {
      $('#engBtn').hide()
      $('#freBtn').show()
      $('#regEn').show()
      $('#regFr').hide()
    },
    getDob (e) {
      if (e.target.value.split(',')[1] >= (new Date().getFullYear() - 15)) {
        this.dobErr = 'Please enter a valid date of birth'
      } else {
        this.formData.dob = e.target.value
        this.dobErr = ''
      }
    },
    assignState () {
      this.allcountries.forEach(d => {
        if (d.name === this.formData.country) {
          this.countryId = d.id
        }
      })
      this.allStates = countries.getStatesOfCountry(this.countryId)
    },
    assignRegion () {
      this.allStates.forEach(s => {
        if (s.name === this.formData.state) {
          this.stateId = s.id
        }
      })
      this.allLgs = countries.getCitiesOfState(this.stateId)
    },
    toCapitalize (capitalizeMe) {
      capitalizeMe = capitalizeMe.trim()
      let obtained = []
      let capitalizeVal = capitalizeMe.toLowerCase().split(' ')
      capitalizeVal.forEach(word => {
        let newWord = word.split('')
        newWord[0] = newWord[0].toUpperCase()
        newWord = newWord.join('')
        obtained.push(newWord)
      })
      capitalizeMe = obtained.join(' ')
      return capitalizeMe
    },
    isValidText (text) {
      if (!text || text === '') {
        return false
      }
      text = text.trim()
      // text = this.toCapitalize(text)
      if (text === '' || !text) {
        return false
      }

      let validateText = /^[a-z0123456789A-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u
      return validateText.test(text)
    },
    isValidEmail (email) {
      if (!email || email === '') {
        return false
      }
      email = email.toLowerCase()
      email = email.trim()
      if (email === '' || !email) {
        return false
      }
      let regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
      return regex.test(email)
    },
    validateForm (e) {},
    async registerCandidate () {
      let validateReg = {}
      if (this.formData.fullName && isNaN(this.formData.fullName) && this.formData.fullName.length >= 7 && this.isValidText(this.formData.fullName) && this.toCapitalize(this.formData.fullName)) {
        this.formData.fullName = this.formData.fullName
        validateReg.fullName = this.toCapitalize(this.formData.fullName)
        this.errorMsg = ''
      } else {
        this.formData.fullName = ''
        this.errorMsg = 'Please enter a valid full name!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.gender) {
        validateReg.gender = this.formData.gender
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please select your gender!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.email && this.isValidEmail(this.formData.email)) {
        validateReg.email = this.formData.email.toLowerCase()
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Invalid email address!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.tel) {
        validateReg.tel = this.formData.tel
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide your phone number!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.dob) {
        validateReg.dob = this.formData.dob
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please provide your date of birth!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.photoUrl) {
        validateReg.photoUrl = this.formData.photoUrl
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please upload your passport!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.institution && this.formData.institution.length >= 5 && this.isValidText(this.formData.institution)) {
        validateReg.institution = this.formData.institution
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please enter valid name of your institution!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.idUrl) {
        validateReg.idUrl = this.formData.idUrl
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please upload your scanned copy of your identification!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.country) {
        validateReg.nationality = this.formData.country
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Please select your country!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.state) {
        validateReg.state = this.formData.state
        this.errorMsg = ''
      } else if (!this.formData.state && this.allStates.length > 0) {
        this.errorMsg = 'Please select your state/province!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.lga) {
        validateReg.lga = this.formData.lga
      } else if (!this.formData.lga && this.allLgs.length > 0) {
        this.errorMsg = 'Please select your region/city!'
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.address && this.formData.address.length >= 10 && this.isValidText(this.formData.address)) {
        validateReg.address = this.formData.address
        this.errorMsg = ''
      } else {
        this.errorMsg = 'A valid address is required!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.bankName && this.formData.bankName.length >= 3 && this.isValidText(this.formData.bankName)) {
        validateReg.bankName = this.formData.bankName
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Your bank details is required!'
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.bankAcctNo) {
        validateReg.bankAcctNo = this.formData.bankAcctNo
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Your bank details is required!'
        // this.responseNote = this.errorMsg
        this.responseTrigger.open()
        return this.errorMsg
      }
      if (this.formData.rCode) {
        validateReg.rCode = this.formData.rCode
        this.errorMsg = ''
      } else {
        this.errorMsg = 'Registration code is required!'
        // this.responseNote = this.errorMsg
        // alert(this.errorMsg)
        this.responseTrigger.open()
        return this.errorMsg
      }
      // console.log({validateReg})
      document.getElementById('registerCandidateBtn').setAttribute('disabled', 'disabled')
      document.getElementById('spinner-load').style.display = 'block'
      document.getElementById('registerCandidateBtn').innerHTML = 'Registering...'
      try {
        const response = (await AuthService.registerCandidate(validateReg)).data
        if (response) {
          document.getElementById('registerCandidateBtn').removeAttribute('disabled')
          document.getElementById('spinner-load').style.display = 'none'
          $('#registerCandidateBtn').innerHTML = 'Register'
        }
        this.errorMsg = response
        this.responseTrigger.open()
        setTimeout(() => {
          this.$router.push('/')
        }, 12500)
        return response
      } catch (error) {
        if (error.response.data) {
          this.errorMsg = error.response.data
          // this.responseNote = this.errorMsg
          // alert(this.errorMsg)
          this.responseTrigger.open()
          document.getElementById('spinner-load').style.display = 'none'
          document.getElementById('registerCandidateBtn').removeAttribute('disabled')
          document.getElementById('registerCandidateBtn').innerHTML = 'Register'
        } else {
          alert('No internet connection')
        }
      }
    },
    upload (formData) {
      // const url = `http://localhost:7070/handleUploads/passport`
      const url = `https://cbt-testing.herokuapp.com/handleUploads/passport`
      return axios.post(url, formData)
      // get data
        .then((x) => {
          if (x) {
            this.imgUrl = x.data
            // console.log(x.data)
            this.formData.photoUrl = x.data
            return x.data
          }
        })
        .catch(error => {
          this.currentStatus = STATUS_FAILED
          this.failText = error.response.data
          // console.log(error.response.data)
        })
    },
    uploadId (formData) {
      // const url = `http://localhost:7070/handleUploads/id`
      const url = `https://cbt-testing.herokuapp.com/handleUploads/id`
      return axios.post(url, formData)
      // get data
        .then((x) => {
          if (x) {
            this.idUrl = x.data
            // console.log(x.data)
            this.formData.idUrl = x.data
            return x.data
          }
        })
        .catch(error => {
          this.currentStatus = STATUS_FAILED_ID
          this.failIdText = error.response.data
          // console.log(error.response.data)
        })
      // // add url field
      //     .then(x => x.map(img => Object.assign({},
      //       img, { url: `http:localhost:3050/public/uploads/${img.id}` })))
    },
    resetId () {
      this.currentStatus = STATUS_INITIAL_ID
      this.uploadedIds = []
      this.uploadError = null
    },
    reset () {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      this.upload(formData)
        .then(x => {
          this.imgUrl = x.data
          this.uploadedFiles = [].concat(x)
          this.currentStatus = STATUS_SUCCESS
          // this.$eventBus.$emit('img-uploaded', {
          //   index: this.id,
          //   url: x.data
          // })
        })
        .catch(err => {
          // console.log({err})
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED
        })
    },
    saveId (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING_ID

      this.uploadId(formData)
        .then(x => {
          this.idUrl = x.data
          this.uploadedIds = [].concat(x)
          this.currentStatus = STATUS_SUCCESS_ID
          // this.$eventBus.$emit('img-uploaded', {
          //   index: this.id,
          //   url: x.data
          // })
        })
        .catch(err => {
          // console.log({err})
          this.uploadError = err.response
          this.currentStatus = STATUS_FAILED_ID
        })
    },
    idChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      // save it
      this.saveId(formData)
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      // save it
      this.save(formData)
    },
    closeUploader () {
      // if (this.imgUrl.length > 0) {
      //   this.$eventBus.$emit('delete-image-url')
      // }
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    dropformstyle () {
      if (!this.isSuccess) {
        return {outline: '2px dashed grey'}
      } else {
        return {}
      }
    },
    isInitialId () {
      return this.currentStatus === STATUS_INITIAL_ID
    },
    isSavingId () {
      return this.currentStatus === STATUS_SAVING_ID
    },
    isSuccessId () {
      return this.currentStatus === STATUS_SUCCESS_ID
    },
    isFailedId () {
      return this.currentStatus === STATUS_FAILED_ID
    },
    dropformstyleId () {
      if (!this.isSuccessId) {
        return {outline: '2px dashed grey'}
      } else {
        return {}
      }
    }
  }
}
</script>

<style>
.input-field>label {
  top: -21px;
}
div.registerCandidate > div.modal-component > div.modal.open > div.modal-content.center-align.text-center > h4 {
  font-size: 1.9rem !important;
}
div.registerCandidate > div.registrationPanel > div > div.col.s12.m8.white.offset-m1 {
  margin-top: 0rem;
}
div.registerCandidate > div.registrationPanel > div > div.col.s12.m3.white.z-depth-1 > p.instructionText > ul > li {
    padding: 0.8rem 0rem;
}
div.registerCandidate > div.registrationPanel  select {
  background-color: #424242;
  color: #fff;
}
div.registerCandidate > div.registrationPanel > div {
  padding: 0 1rem;
}
div.registerCandidate > div.registrationPanel > div > div.col.s12.m8.white.offset-m1 > div > form > div > div > label.active {
  font-size: 1.5rem;
  color: #616161;
}
h3.text-center.center-align.header.application {
  font-size: 2rem;
}
div.registerCandidate > div.registrationPanel > div > div.col.s12.m8.white.offset-m1 {
  border: 0px groove grey;
}
div.registerCandidate > div.registrationPanel > div > div.col.s12.m8.white.offset-m1 > div {
  padding: 1.5rem 1rem;
}
input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not (.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:active:not([readonly]),
input:not([type]):active:not([readonly]), input[type=text]:not(.browser-default):active:not([readonly]), input[type=password]:not(.browser-default):active:not([readonly]), input[type=email]:not(.browser-default):active:not([readonly]), input[type=url]:not(.browser-default):active:not([readonly]), input[type=time]:not(.browser-default):active:not([readonly]), input[type=date]:not(.browser-default):active:not([readonly]), input[type=datetime]:not(.browser-default):active:not([readonly]), input[type=datetime-local]:not(.browser-default):active:not([readonly]), input[type=tel]:not(.browser-default):active:not([readonly]), input[type=number]:not(.browser-default):active:not([readonly]), input[type=search]:not(.browser-default):active:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) {
  border-bottom: 1px solid #2691f3;
  box-shadow: 0 1px 0 0 #2691f3;
}
  input:not([type]):focus:not([readonly])+label, input[type=text]:not(.browser-default):focus:not([readonly])+label, input[type=password]:not(.browser-default):focus:not([readonly])+label, input[type=email]:not(.browser-default):focus:not([readonly])+label, input[type=url]:not(.browser-default):focus:not([readonly])+label, input[type=time]:not(.browser-default):focus:not([readonly])+label, input[type=date]:not(.browser-default):focus:not([readonly])+label, input[type=datetime]:not(.browser-default):focus:not([readonly])+label, input[type=datetime-local]:not(.browser-default):focus:not([readonly])+label, input[type=tel]:not(.browser-default):focus:not([readonly])+label, input[type=number]:not(.browser-default):focus:not([readonly])+label, input[type=search]:not(.browser-default):focus:not([readonly])+label, textarea.materialize-textarea:focus:not([readonly])+label {
    color: #212121;
  }
  .datepicker-date-display {
    background-color: #2691f3;
  }
  .datepicker-cancel, .datepicker-clear, .datepicker-today, .datepicker-done {
    color: #2691f3;
  }
  .datepicker-table td.is-today {
    color: #2691f3;
  }
  .datepicker-table td.is-selected {
    background-color: #2691f3;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/registration/registration.vue